// Mock data for the Colic Coverage Review screen. Mirrors the approved HTML
// (06-Colic-Coverage-Review.html). Represents Doug's actual world: Sarah
// Mitchell with Duke (Quarter Horse, Reining) and a Gut X subscription.
//
// TODO(runtime): swap mock -> real API calls once the following land:
//   - services/customer-coverage (coverage assignment record)
//   - dist/account-workflows.applications (application+coverage status;
//     already seeds Sarah/Duke with "Needs information" + missing fields
//     "Horse date of birth", "Completed enrollment checks")
//   - services/horse-timeline for horse profile + coverage events

export type ApplicationStatus = 'Needs information' | 'Approved' | 'Submitted' | 'Not submitted';
export type CoverageStatus = 'Confirmed' | 'Not confirmed' | 'Pending acceptance';
export type SubscriptionStatus = 'Present' | 'Not present' | 'Paused';

export interface AttentionItem {
  key: string;
  title: string;
  body: string;
  actionLabel: string;
  actionVariant: 'primary' | 'outlined';
}

export interface EnrollmentStep {
  index: number;
  title: string;
  detail: string;
  state: 'incomplete' | 'pending' | 'done';
}

export interface CoverageHorse {
  id: string;
  initial: string;
  name: string;
  breed: string;
  discipline: string;
  applicationStatus: ApplicationStatus;
  subscriptionStatus: SubscriptionStatus;
  subscriptionNote: string;
  coverageStatus: CoverageStatus;
  attention: AttentionItem[];
  enrollmentSteps: EnrollmentStep[];
  relatedProduct: {
    name: string;
    square: string;
    note: string;
  };
}

export const DUKE_COVERAGE: CoverageHorse = {
  id: 'horse_duke',
  initial: 'D',
  name: 'Duke',
  breed: 'Quarter Horse',
  discipline: 'Reining',
  applicationStatus: 'Needs information',
  subscriptionStatus: 'Present',
  subscriptionNote: 'Qualifying supply not verified',
  coverageStatus: 'Not confirmed',
  attention: [
    {
      key: 'dob',
      title: 'Horse date of birth',
      body: "Confirm Duke's date of birth with Sarah.",
      actionLabel: 'Add details',
      actionVariant: 'primary',
    },
    {
      key: 'checks',
      title: 'Completed enrollment checks',
      body: 'Review the current program requirements and missing information.',
      actionLabel: 'Review checklist',
      actionVariant: 'outlined',
    },
  ],
  enrollmentSteps: [
    {
      index: 1,
      title: 'Application details',
      detail: 'More information needed',
      state: 'incomplete',
    },
    {
      index: 2,
      title: 'Written acceptance',
      detail: 'Not recorded',
      state: 'pending',
    },
    {
      index: 3,
      title: 'Qualifying period',
      detail: 'Not started',
      state: 'pending',
    },
    {
      index: 4,
      title: 'Active coverage',
      detail: 'Not confirmed',
      state: 'pending',
    },
  ],
  relatedProduct: {
    name: 'Gut X',
    square: 'GX',
    note: 'Subscription present',
  },
};

export const COVERAGE_HORSES: CoverageHorse[] = [DUKE_COVERAGE];
